export function cleanChartConfig (config) {
  return Object.fromEntries(
    Object.entries(config).filter(([, v]) => v !== undefined)
  )
}
